<template>
  <div
    v-show="!swiper.isBeginning"
    class="absolute top-0 z-2 hidden h-full w-1/2 cursor-none lg:block"
    :class="decreasedHeight && 'lg:h-[90%]'"
    @mouseover="
      emitterEmit('hotspotEnter', {
        label: 'Prev',
        universal: true,
        iconLeft: 'custom:chevron-left'
      })
    "
    @mouseleave="emitterEmit('hotspotLeave')"
    @click="handlePrev"
  ></div>
  <div
    v-show="!swiper.isEnd"
    class="absolute right-0 top-0 z-2 hidden h-full w-1/2 cursor-none lg:block"
    :class="decreasedHeight && 'lg:h-[90%]'"
    @mouseover="
      emitterEmit('hotspotEnter', {
        label: 'Next',
        universal: true,
        iconRight: 'custom:chevron-right'
      })
    "
    @mouseleave="emitterEmit('hotspotLeave')"
    @click="handleNext"
  ></div>
</template>

<script setup lang="ts">
import { useSwiper } from 'swiper/vue'

defineProps({
  decreasedHeight: {
    type: Boolean,
    default: false
  }
})

const swiper = useSwiper()
const { emitterEmit } = useEmitter()

function handlePrev() {
  swiper.value.slidePrev()
  emitterEmit('hotspotEnter', {
    label: 'Prev',
    universal: true,
    iconLeft: 'custom:chevron-left'
  })
}

function handleNext() {
  swiper.value.slideNext()
  emitterEmit('hotspotEnter', {
    label: 'Next',
    universal: true,
    iconRight: 'custom:chevron-right'
  })
}
</script>
